export default {"src":"/_next/static/media/folder.9ec2f0a2.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};